export default __webpack_public_path__ + "static/media/logo_groupe.224c2290.svg";